import { useTranslation } from 'react-i18next';
import { postsTranslations } from '../translations/postsTranslations';

export const usePostsTranslation = () => {
  const { i18n } = useTranslation();
  
  // Get current language, fallback to English if not supported
  const currentLang = ['en', 'fr', 'es', 'ar'].includes(i18n.language) 
    ? i18n.language 
    : 'en';
  
  // RTL support for Arabic
  const isArabic = currentLang === 'ar';
  const rtlDirection = isArabic ? 'rtl' : 'ltr';
  
  // Translation function that uses our dedicated translations
  const t = (key) => {
    // Handle nested keys like 'posts.categories.coffee'
    const keyParts = key.startsWith('posts.') ? key.slice(6).split('.') : key.split('.');
    let value = postsTranslations[currentLang];
    
    for (const part of keyParts) {
      value = value?.[part];
    }
    
    // Fallback to English if not found
    if (!value) {
      let fallbackValue = postsTranslations.en;
      for (const part of keyParts) {
        fallbackValue = fallbackValue?.[part];
      }
      value = fallbackValue;
    }
    
    return value || key;
  };
  
  return {
    t,
    i18n,
    currentLanguage: currentLang,
    isArabic,
    rtlDirection
  };
};
